import React from 'react';
import { useNavigate } from 'react-router-dom'; 
import './Team.css';
import { Heading, TeamItem } from '../../../components';
import { team } from '../../../constants';

const Team = () => {
  const navigate = useNavigate();

  return (
    <section className='team'>
      <Heading title={'Fundacji Dwór Imielno:'} subTitle={'Skład Rady Naukowej'} />

      {/* Dodany wstęp tekstowy */}
      <div className="team-intro">
        <p>
          Rada Naukowa Fundacji Dwór Imielno, to zespół ludzi nauki, reprezentantów uczelni wyższych, przedstawicieli ogrodów botanicznych, pasjonatów i praktyków ogrodnictwa. Specjalistów, którzy widząc duży potencjał Zabytkowego Zespołu Dworsko-Parkowego w Imielnie, jak również ogromne zaangażowanie, zapał i pasję właściciela obiektu z przyjemnością będą wspierać działania Fundacji, aby zachowane zostały najwyższe standardy tego typu obiektów.
        </p>
        <p>
          Projekt rewitalizacji zabytkowego założenia parkowego, połączony z powstaniem nowego ogrodu botanicznego specjalizującego się w kolekcjach historycznych odmian roślin ozdobnych i użytkowych oraz kolekcjach róż, połączony ze zbiorami Muzeum Ogrodnictwa i działaniami w zakresie czynnej ochrony przyrody, jest bardzo ciekawym, wartościowym, a zarazem trudnym przedsięwzięciem.
        </p>
        <p>
          Dlatego deklarując wsparcie projektu swoją wiedzą i doświadczeniem zawodowym, życzymy wytrwałości i osiągnięcia zamierzonego celu.
        </p>
        <p className="team-signature">
          W imieniu członków Rady Naukowej Dwór Imielno<br />
          <strong>Dorota Mańkowska – Przewodnicząca Rady</strong>
        </p>
      </div>

      <div className='box-container'>
        {team.map((item) => (
          <TeamItem 
            key={item.id}
            image={item.image}
            name={item.name}
            title={item.title}
            accounts={item.accounts}
            team={item}
          /> 
        ))}
      </div>

      {/* Kontener na guzik */}
      <div className="team-footer">
        <button className="gallery-btn-green" onClick={() => navigate('/RadaNaukowa/Galeria')}>
          Zobacz Galerię Zdjęć
        </button>
      </div>

    </section>
  )
}

export default Team;